import { render, staticRenderFns } from "./SingleStudentGradeBook.vue?vue&type=template&id=4ef97bfe&scoped=true"
import script from "./SingleStudentGradeBook.vue?vue&type=script&lang=js"
export * from "./SingleStudentGradeBook.vue?vue&type=script&lang=js"
import style0 from "./SingleStudentGradeBook.vue?vue&type=style&index=0&id=4ef97bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef97bfe",
  null
  
)

export default component.exports